import queryString from 'query-string';

import { AvailabilitySearchUrlQuery } from '../dtos/availability-search-url-query.dto';

export const availabilityQueryToURLParamString = (
  query: AvailabilitySearchUrlQuery
): string => queryString.stringify(query);
